export var DateTimePickerStylePropertiesByState = {
    default: function (theme) { return ({
        color: theme.contentPrimary,
        backgroundColor: theme.backgroundUI,
        border: theme.borderSecondary,
        borderHover: theme.borderTertiary,
        borderFocus: theme.borderAccent,
        iconColor: theme.contentPrimary,
        microTextColor: theme.contentTertiary,
    }); },
    disabled: function (theme) { return ({
        color: theme.disabledSecondary,
        backgroundColor: theme.backgroundUI,
        border: theme.disabledPrimary,
        borderHover: theme.disabledSecondary,
        borderFocus: theme.disabledSecondary,
        iconColor: theme.disabledPrimary,
        microTextColor: theme.disabledSecondary,
    }); },
    locked: function (theme) { return ({
        color: theme.contentPrimary,
        backgroundColor: theme.backgroundTertiary,
        border: theme.borderSecondary,
        borderHover: theme.borderSecondary,
        borderFocus: theme.borderSecondary,
        iconColor: theme.contentPrimary,
        microTextColor: theme.contentTertiary,
    }); },
    error: function (theme) { return ({
        color: theme.contentPrimary,
        backgroundColor: theme.backgroundUI,
        border: theme.borderNegative,
        borderHover: theme.borderNegative,
        borderFocus: theme.borderNegative,
        iconColor: theme.contentPrimary,
        microTextColor: theme.contentTertiary,
    }); },
};
//# sourceMappingURL=DateTimePickerStylePropertiesByState.js.map